<template>
<!--    编辑生产单-->
    <div class="pd video-tree">
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">
            <h3 style="text-align: center;"><span v-if="i_id==0">{{$t('button_newly_added')}} </span>{{$t('promanagement_production_task_order')}}</h3>
                <el-form-item class="form-title num" prop="num" label="No:" >
                    <span  v-model="formData.num" style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.num}}</span>
                </el-form-item>
                <div class="item">
                    <el-form-item class="form-title" prop="gsname" :label="$t('form_company')" >
                        <el-select v-model="formData.gsname" :placeholder="$t('form_please_select_a_company')" @change="changeCompany" filterable required clearable :disabled="edit" style="width:240px">
                            <el-option
                                    v-for="item in companyName"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="cjname" :label="$t('form_workshop_department')" >
                        <el-select v-model="formData.cjname" :placeholder="$t('form_please_select_department')" @change="changeGroup" filterable required clearable :disabled="edit" style="width:240px">
                            <el-option
                                    v-for="itembm in groupName"
                                    :key="itembm.i_id"
                                    :label="itembm.vc_name"
                                    :value="itembm.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{itembm.vc_name}}</span>-->
                            </el-option>

                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="type" :label="$t('promanagement_type')" >
                        <el-select v-model="formData.i_type"  filterable required  :disabled="i_id==0?true:disabled" style="width:240px">
                            <el-option
                                    v-for="item in typeData"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>

                        </el-select>
                    </el-form-item>
                    <!--<el-form-item class="form-title" prop="zdname" label="制定人" >
                        <el-select v-model="formData.zdname" placeholder="请选择制定人"  @change="changePerson" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="itemsq in personName"
                                    :key="itemsq.i_id"
                                    :label="itemsq.vc_name"
                                    :value="itemsq.i_id">
                                &lt;!&ndash;                                <span style="display: inline-block;width: 100%">{{itemsq.vc_name}}</span>&ndash;&gt;
                            </el-option>

                        </el-select>
                    </el-form-item>-->
                </div>
                <div class="item">
                    <el-form-item class="form-title" prop="proname" :label="$t('form_product')" >
                        <el-select v-model="formData.proname" :placeholder="$t('form_please_select_a_product')" @change="changePro" filterable required clearable :disabled="edit" style="width:240px">
                            <el-option
                                    v-for="one in proList"
                                    :key="one.i_id"
                                    :label="one.vc_pzname"
                                    :value="one.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{one.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="ckname" :label="$t('form_warehouse')" >
                        <el-select v-model="formData.ckname" :placeholder="$t('form_please_select_warehouse')"  @change="changeWarehouse" filterable required clearable :disabled="edit" style="width:240px">
                            <el-option v-for="one in warehouseName" :key="one.i_id" :label="one.vc_name" :value="one.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{one.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="shul" :label="$t('form_quantity')" >
                        <el-input-number  type="number" :disabled="this.i_id!==0" :controls="false" :precision="2" v-model="formData.f_num" :min="0" style="width:240px">
                        </el-input-number>{{pzunit}}
                    </el-form-item>
                </div>
                <div class="item">
                    <el-form-item v-if="formData.i_type==3" class="form-title" prop="i_processingvendor" :label="$t('promanagement_entrusted_factory')" >
                        <el-select v-model="formData.i_processingvendor" :placeholder="$t('form_please_select')" filterable required clearable :disabled="edit" style="width:240px">
                            <el-option v-for="item in wtgsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="formData.i_type==1" class="form-title" prop="i_consignor_id" :label="$t('purchaseOrder_client')" >
                        <el-select v-model="formData.i_processingvendor" :placeholder="$t('form_please_select')" filterable required clearable :disabled="edit" style="width:240px">
                            <el-option v-for="item in wtgsList" :key="item.i_khid" :label="item.vc_khname" :value="item.i_khid">
                                <!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="begintime" :label="$t('form_start_time')" >
                        <el-date-picker style="width:240px" @change="getLastDay" disabled v-model="formData.begintime"
                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" :placeholder="$t('form_select_date')">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="form-title" prop="endtime" :label="$t('form_end_time')" >
                        <el-date-picker style="width:240px" disabled :picker-options="pickerOptions" v-model="formData.endtime"
                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" :placeholder="$t('form_select_date')">
                        </el-date-picker>
                    </el-form-item>

                </div>
            <el-form-item class="form-title" prop="vc_note" :label="$t('form_notes')" >
                <el-input  v-model="formData.vc_note" style="width:880px"></el-input>
            </el-form-item>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_input_person')" >
                    <el-input  v-model="formData.vc_lruname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="date" :label="$t('form_date')" >
                    <el-input  v-model="formData.date" disabled>
                    </el-input>
                </el-form-item>

            </div>
            <el-form-item class="form-title" prop="tableData">
                <el-table  @row-click="selectItem" ref="baseForm" border :data="formData.tableData" style="margin-left: -80px;width:960px;max-height: 350px;overflow: auto;">
                    <template slot="empty">
                        <span @click="addRow">{{$t('promanagement_click_to_add_plan')}}</span>
                    </template>
                    <el-table-column type="index" width="40">
                    </el-table-column>
                    <el-table-column min-width="190" :label="$t('form_date')" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-date-picker :disabled="scope.row.i_id!==0" type="date" :picker-options="pickerOpt" :default-value="timeDefaultShow"
                                    value-format="yyyy-MM-dd" style="width: 160px;" v-model="scope.row.dt_day" :placeholder="$t('form_select_date')">
                            </el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="190" prop="name" :label="$t('promanagement_planned_quantity')" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-input :disabled="scope.row.i_id!==0" type="number" style="width: 160px;" :placeholder="$t('promanagement_please_enter_the_content')"
                                    v-model.number="scope.row.f_num" clearable @blur="totalcount" step="0.01">
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="190" :label="$t('form_input_person')" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-input style="width: 160px;" :placeholder="$t('promanagement_please_enter_the_content')"
                                      v-model="scope.row.vc_lruname" clearable disabled>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="190" :label="$t('form_enter_time')" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-input style="width: 160px;" :placeholder="$t('promanagement_please_enter_the_content')"
                                      v-model="scope.row.dt_createtime" clearable disabled>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="120" :label="$t('form_operate')" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-plus" @click="addLine"></el-button>
                            <el-button v-if="scope.row.i_id==0" type="text" icon="el-icon-minus"  @click.native.prevent="deleteRow(scope.$index, formData.tableData,scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item class="form-title form-heji" :label="$t('promanagement_amount_to')" style="color: black">
<!--                <el-input style="width: 160px;" v-model="total" >-->
<!--                </el-input>-->
                {{formData.total}}

            </el-form-item>
        </el-form>
        <div slot="footer"  class="dialog-footer" style="text-align: center">
<!--            <el-button @click="cancel">取 消</el-button>-->
            <el-button type="primary" @click="saveForm" :class="baseerp+'btn'" :disabled="disabled" size="mini">{{$t('button_save')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "ProDetails",
        props:{
            formvalue:{
                type:Object,
                required:true,

            },
            datevalue:{
                type:String
            }
        },
        data() {
            return {
                pickerOpt:{
                    disabledDate: (time) => {
                        return this.Disabledate(time)
                    }
                },
                total:[],
                disable:false,
                baseerp:"",
                edit:false,
                proname:"",
                formData:{
                    gsname:"",
                    cjname:"",
                    // zdname:"",
                    proname:"",
                    ckname:"",
                    begintime:"",
                    endtime:"",
                    shul:0,
                    num:"000000",
                    vc_note:"",
                    vc_lruname: sessionStorage.getItem("lruname"),
                    date:"",
                    tableData: [],
                    total:0,
                    delList:[],//删除数组
                    f_num:0,
                    i_type:0,
                    i_processingvendor:null,
                    //i_consignor_id:null,

                },
                formRules:{
                    /*gsname:[{required:true,message:"请选择公司",trigger:"change"}],
                    cjname:[{required:true,message:"请选择车间",trigger:"change"}],
                    zdname:[{required:true,message:"请选择制定人",trigger:"change"}],
                    proname:[{required:true,message:"请选择产品",trigger:"change"}],
                    ckname:[{required:true,message:"请选择仓库",trigger:"change"}],
                    jgcost:[{required:true,message:"请输入加工费",trigger:"blur"}],
                    shul:[{required:true,message:"请输入数量",trigger:"blur"}],
                    endtime:[{required:true,message:"请选择结束日期",trigger:"change"}],
                    begintime:[{required:true,message:"请选择开始日期",trigger:"change"}],*/
                },
                rowNum:1,
                companyName:[],
                groupName:[],
                personName:[],
                proList:[],
                warehouseName:[],
                gsid:0,
                ckid:0,
                pzid:0,
                cjid:0,
                i_id:0,
                i_type:9,
                wtgsid:0,
                zduid:0,
                // zdname:"",
                pzname:"",
                pzunit:this.$t('promanagement_ton'),
                wtname:"",
                gsname:"",
                cjname:"",
                lastTime:"",
                disabled:false,
                mid:0,
                index:0,
                olddata:[],
                newdata:[],
                saveList:[],
                deli_id:0,
                timeDefaultShow:'',
                typeData:[{i_id:0,vc_name:this.$t('promanagement_self-produced')},{i_id:1,vc_name:this.$t('promanagement_oem')},{i_id:2,vc_name:this.$t('promanagement_r&d')},{i_id:3,vc_name:this.$t('promanagement_o&p')}],
                wtgsList:[],
                wtfData:[],
            }
        },
        watch:{
            datevalue(){
                if (this.datevalue){
                    this.timeDefaultShow=new Date(this.datevalue)

                    // this.getScorder();
                    // this.taskList()
                    // console.log(this.formvalue,"this.formvalue");

                }
            },
            formvalue:{
                handler(){
                    if (this.formvalue){
                        //this.disabled=false;
                        this.mid=this.formvalue.i_mid;
                        if(this.i_id!=this.formvalue.i_id){
                            //console.log("a");
                            this.form=this.formvalue;
                            this.currentDate()
                            this.i_id=this.form.i_id;
                            //this.disabled = false;
                            if ((this.form.i_id??''!=='')&&this.i_id!=0){
                                //console.log("c");
                                this.i_type=this.form.i_type;
                                this.edit=true;
                                this.getScorder();
                               /* if (this.formvalue.value.dt_createtime>=this.formvalue.value.dt_starttime&&this.formvalue.value.dt_createtime<=this.formvalue.value.dt_endtime){
                                    this.disabled=false;
                                    //console.log(this.formvalue.value.dt_createtime,this.formvalue.value.dt_starttime,this.formvalue.value.dt_endtime,"check")
                                }else{
                                    this.disabled=true;
                                };*/
                                if(this.formvalue.value.jz==true){
                                    this.disabled=true;
                                }else{
                                    this.disabled=false;
                                }
                            }else if(this.i_id==0){
                                //console.log("d");
                                this.newData();
                                //this.currentDate()
                            }
                        }else if (this.i_id==0&&(this.i_type!=this.formvalue.i_type)){
                            //console.log("b");
                            this.newData();
                            //this.currentDate()

                        }


                    }
                    //console.log("formvalue",this.formvalue)
                },
                immediate:true,
                deep:true
            }

        },
        mounted() {
            // if(this.datevalue==0){

            this.timeDefaultShow=new Date(this.datevalue)
            // }
            this.gettime()
            //console.log(this.datevalue)
            // this.formData.vc_lruname=sessionStorage.getItem("lruname"),;
            this.baseerp=baseerp;
            this.olddata=JSON.parse(JSON.stringify(this.formData.tableData))
        },
        computed:{
            //禁止跨月
            pickerOptions(){
                let _this = this
                return {
                    disabledDate(time) {
                        let start = new Date(_this.lastTime);
                        start.setDate(start.getDate());
                        return time.getTime() > start.getTime();
                    }
                }
            }
        },
        methods: {
            //判断表格内时间
            Disabledate(time){
                var now = new Date(); //当前日期
                let searchdate=this.datevalue.substring(5,7)
                // console.log(searchdate)
                var nowMonth = now.getMonth(); //当前月
                // console.log(nowMonth)
                var nowYear = now.getFullYear(); //当前年
                var monthEndDate = new Date(nowYear, nowMonth + 1, 0);
                let newnowMonth=0
                if(nowMonth<10){
                    newnowMonth='0'+(nowMonth+1)
                }else {
                    newnowMonth=nowMonth+1+''
                }
                // console.log(searchdate==newnowMonth)
                if(searchdate==newnowMonth){
                    return time.getTime()<Date.now()-8.64e7||time.getTime()>monthEndDate;
                }else {
                    const date = new Date(this.datevalue)
                    const year = date.getFullYear()
                    let month = date.getMonth() + 1
                    if (month >= 1 && month <= 9) {
                        month = '0' + month
                    }
                    const currentdate = year.toString() + month.toString()
                    const timeyear = time.getFullYear()
                    let timemonth = time.getMonth() + 1
                    if (timemonth >= 1 && timemonth <= 9) {
                        timemonth = '0' + timemonth
                    }
                    const timedate = timeyear.toString() + timemonth.toString()
                    // 当月
                    return timedate < currentdate || currentdate < timedate

                }

            },
            //table没数据时点击新增
            addRow(){
                this.addLine()
            },
            gettime(){
                var date=new Date;
//获得页面的日期
                var this_month = this.datevalue;
                var this_year =  date.getFullYear();
                var this_month_dateTotal ="";

//将获得到的日期做字符串截取
                this_month=this_month.substring(5,7)

//判断大小月

                if(this_month==2){
                    this_month_dateTotal=28
                }

                if(this_month==4||this_month==6||this_month==9||this_month==11){
                    this_month_dateTotal=30
                }

                if(this_month==1||this_month==3||this_month==5||this_month==7||this_month==8||this_month==10){
                    this_month_dateTotal=31
                }

                let thisStartDate=this_month+"/1/"+this_year;
                let  thisEndDate=this_month+"/"+this_month_dateTotal+"/"+this_year;
                // console.log(thisStartDate,thisEndDate,123123)
                // console.log("//年:"+this_year+"//获得月份为:"+this_month+"//当月天数:"+this_month_dateTotal)
            },
            currentDate(){
                var date = new Date(this.datevalue) // this.startTime = '2022-5-02'
                var new_year = date.getFullYear() // 取当前的年份
                var month = date.getMonth()

                var new_month = month + 1 // 取当前的月份
                if (month > 12) {
                    new_month -= 12 // 月份减
                    new_year++ // 年份增
                }
                // if(new_month==12){
                    // var firstDay = new Date(new_year, new_month-1, 1) // 取当年当月中的第一天

                // }else{
                    var firstDay = new Date(new_year, new_month, 1) // 取当年当月中的第一天

                // }
                var lastDay = new Date(firstDay.getTime() - 1000 * 60 * 60 * 24).getDate() // 获取当月最后一天日期
                if(new_month==12&&firstDay.getMonth()==0){
                    // if (firstDay.getMonth() < 10) {
                    // var mon =  firstDay.getMonth()-1+"0"
                    // } else {
                    var mon = 12
                    var newfullyear=firstDay.getFullYear()-1
                    // }
                }else{
                    if (firstDay.getMonth() < 10) {
                        var mon = "0" + firstDay.getMonth()
                    } else {
                        var mon = firstDay.getMonth()
                    }
                    var newfullyear=firstDay.getFullYear()

                }
                var startDate = newfullyear + '-' + mon + '-' + "0" + firstDay.getDate();
                var endDate = newfullyear + '-' + mon + '-' + lastDay;
                //console.log(startDate,endDate)
                this.formData.begintime=startDate
                this.formData.endtime=endDate
                //console.log("currentDate",this.formData.begintime,this.formData.endtime)
            },
            totalcount(){
                //计算合计
                let total=this.formData.tableData.map(item=>{
                    return  item.f_num
                })
                //console.log(total)
                let total1=total.map(Number)
                let total2=total1.reduce(function (sum, current) {
                    return sum + current;
                }, 0);
                this.formData.total=total2
                this.formData.tableData.forEach(item=>{
                    parseFloat(item.f_num)
                })
                // console.log(this.formData.tableData)
                // console.log(val)
            },
            // 删除指定行
            deleteRow(index, rows,val) {
                // let arr2=this.tableData.filter(item=>{
                //     return item==index
                // })
                this.deli_id=1
                if(val.i_id!==0){


                    this.total.unshift(val.i_id)
                    this.formData.delList=[]
                    // this.formData.delList=this.total

                    // console.log( this.formData.delList)
                }else {
                    this.formData.delList=[]
                }
                // console.log(this.formData.tableData.length)
                rows.splice(index, 1);
                //console.log(val)

                // 如果全部删除后没有可以点击的一行了，需要加一行空行
                // if (this.formData.tableData.length==0) {
                //     this.addLine()
                // }
            },

            //增加行
            addLine () {

                    const newLine = {
                        i_id:0,
                        f_num:0,
                        i_lruid:sessionStorage.getItem("userid"),
                        i_pid:0,
                        vc_lruname:sessionStorage.getItem("lruname"),
                        dt_createtime:'',
                        dt_day:''
                    }
                    this.index++
                    this.formData.tableData.push(newLine)
                //console.log(newLine)
            },
            selectItem(row, column, event) {

            },

            // currentDate(){
            //     var date = new Date(this.datevalue) // this.startTime = '2022-5-02'
            //     var new_year = date.getFullYear() // 取当前的年份
            //     var month = date.getMonth()
            //
            //     var new_month = month + 1 // 取当前的月份
            //     if (month > 12) {
            //         new_month -= 12 // 月份减
            //         new_year++ // 年份增
            //     }
            //     var firstDay = new Date(new_year, new_month, 1) // 取当年当月中的第一天
            //
            //     var lastDay = new Date(firstDay.getTime() - 1000 * 60 * 60 * 24).getDate() // 获取当月最后一天日期
            //     if (firstDay.getMonth() < 10) {
            //         var mon = "0" + firstDay.getMonth()
            //     } else {
            //         var mon = firstDay.getMonth()
            //     }
            //     var startDate = firstDay.getFullYear() + '-' + mon + '-' + "0" + firstDay.getDate();
            //     var endDate = firstDay.getFullYear() + '-' + mon + '-' + lastDay;
            //     this.formData.begintime=startDate
            //     this.formData.endtime=endDate
            // },
            //新增赋值
            newData(){
                var date = new Date() // this.startTime = '2022-5-02'
                var new_year = date.getFullYear() // 取当前的年份
                var month = date.getMonth()

                var new_month = month + 1 // 取当前的月份
                if (month > 12) {
                    new_month -= 12 // 月份减
                    new_year++ // 年份增
                }
                // console.log(new_month)
                // if(new_month==12){
                    var firstDay = new Date(new_year, new_month, 1) // 取当年当月中的第一天
                    // console.log()
                // }else{
                //     var firstDay = new Date(new_year, new_month, 1) // 取当年当月中的第一天
                //
                // }

                var lastDay = new Date(firstDay.getTime() - 1000 * 60 * 60 * 24).getDate() // 获取当月最后一天日期
                if(new_month==12&&firstDay.getMonth()==0){
                    // if (firstDay.getMonth() < 10) {
                    // var mon =  firstDay.getMonth()-1+"0"
                    // } else {
                    var mon = 12
                    var newfullyear=firstDay.getFullYear()-1
                    // }
                }else{
                    if (firstDay.getMonth() < 10) {
                        var mon = "0" + firstDay.getMonth()
                    } else {
                        var mon = firstDay.getMonth()
                    }
                    var newfullyear=firstDay.getFullYear()

                }
                var startDate = newfullyear + '-' + mon + '-' + "0" + firstDay.getDate();
                var endDate = newfullyear + '-' + mon + '-' + lastDay;
                //console.log('startDate',startDate,'endDate',endDate)
                this.form=this.formvalue;
                this.i_id=this.form.i_id;
                this.i_type=this.form.i_type;
                //this.disabled = false;
                //console.log(this.datevalue,'datevalue')
                if(this.datevalue){
                   const nowT = Number((newfullyear + '-' + mon).replace("-", ""));
                   const dateT =  Number(this.datevalue.replace("-", ""));
                   if(nowT>dateT){
                       this.disabled=true;
                   }else{
                       this.disabled=false;
                   }
                 }
                this.formData={
                    begintime:startDate,
                    endtime:endDate,
                    gsname:"",
                    cjname:"",
                    // zdname:"",
                    proname:"",
                    ckname:"",
                    //begintime:"",
                    //endtime:"",
                    vc_note:"",
                    date:"",
                    f_num: 0,
                    num:"000000",
                    vc_lruname: sessionStorage.getItem("lruname"),
                    tableData: [],
                    total:0,
                    i_type:this.i_type,
                };
                //(this.formData.begintime,"begintime")
                //console.log(this.formData.endtime,"endtime")
                this.edit=false;
                this.getCompanyList();
                if(this.formData.i_type==3){
                    this.getkhlist();
                }


                // this.getGroupList();
                this.getWarehouseList();
                this.getDateYYYYMMddHHMMSS();
            },
            async getScorder(){
                let param={
                    i_mid: this.mid,
                    i_type:this.i_type,
                    i_id:this.i_id,
                };
                let res=await API.getScorder(param);
                if(res.code==1){
                    var date = new Date(this.datevalue) // this.startTime = '2022-5-02'
                    var new_year = date.getFullYear() // 取当前的年份
                    var month = date.getMonth()

                    var new_month = month + 1 // 取当前的月份
                    if (month > 12) {
                        new_month -= 12 // 月份减
                        new_year++ // 年份增
                    }
                    // if(new_month==12){
                        // var firstDay = new Date(new_year, new_month-1, 1) // 取当年当月中的第一天

                    // }else{
                        var firstDay = new Date(new_year, new_month, 1) // 取当年当月中的第一天

                    // <!--}-->

                    var lastDay = new Date(firstDay.getTime() - 1000 * 60 * 60 * 24).getDate() // 获取当月最后一天日期
                    if(new_month==12&&firstDay.getMonth()==0){
                        // if (firstDay.getMonth() < 10) {
                            // var mon =  firstDay.getMonth()-1+"0"
                        // } else {
                            var mon = 12
                        var newfullyear=firstDay.getFullYear()-1
                        // }
                    }else{
                        if (firstDay.getMonth() < 10) {
                            var mon = "0" + firstDay.getMonth()
                        } else {
                            var mon = firstDay.getMonth()
                        }
                        var newfullyear=firstDay.getFullYear()

                    }
                    var startDate = newfullyear + '-' + mon + '-' + "0" + firstDay.getDate();
                    var endDate = newfullyear + '-' + mon + '-' + lastDay;
                    let count=res.data.list.map(item=>{
                        return item.f_num
                    })
                    let count1=count.reduce(function (sum, current) {
                        return sum + current;
                    }, 0);
                    // console.log(stat)
                    let data=res.data;
                    // this.formRules={};
                    this.formData={
                        gsname:data.vc_gsname,
                        cjname:data.vc_cjname,
                        // zdname:data.vc_zduname,
                        proname:data.vc_pzname,
                        ckname:data.vc_ckname,
                        begintime:data.dt_starttime,
                        endtime:data.dt_endtime,
                        f_num:data.f_num,
                        num:data.vc_pno,
                        vc_note:data.vc_note,
                        vc_lruname:data.vc_lruname,
                        date:data.dt_createtime,
                        tableData:data.list,
                        total:count1.toFixed(2),
                        //begintime:startDate,
                        //endtime:endDate
                        i_type:data.i_type,
                        i_processingvendor:data.i_processingvendor,
                        //i_consignor_id:data.i_consignor_id,
                    };
                    //console.log("getScorder",this.formData.begintime);
                    this.olddata=JSON.parse(JSON.stringify(this.formData.tableData.map(item=>({
                        i_id:item.i_id,
                        f_num:item.f_num,
                        i_lruid:sessionStorage.getItem("userid"),
                        i_pid:item.i_pid,
                        dt_day:item.dt_day
                    }))))
                        // this.wtgsid=data.i_gsid;
                        this.gsid=data.i_gsid;
                        this.cjid=data.i_cjid;
                        this.ckid=data.i_ckid;
                        this.pzid=data.i_pzid;
                        this.zduid=data.i_zduid;
                        this.pzname=data.vc_pzname;
                        this.pzunit=data.vc_pzunit;
                        this.gsname=data.vc_gsname;
                        this.cjname=data.vc_cjname;
                        this.ckname=data.vc_ckname;
                        // this.zdname=data.vc_zduname;
                        if(this.formData.i_type==1)this.wtflist();
                        if(this.formData.i_type==3)this.getkhlist();

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async wtflist(){
                let param={
                    //vc_search:'',
                    //i_khtype:2,
                    i_gsid:this.gsid,
                };
                let res=await API.getConsignorForOemTask(param);
                if(res.code==1){
                    this.wtgsList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getkhlist(){
                let param={
                    vc_search:'',
                    i_khtype:2,
                };
                let res=await API.getkhlist(param);
                if(res.code==1){
                    this.wtgsList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let param={
                    i_mid: this.mid,
                    i_type:"2"
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                    if (res.data.length>0){
                        this.companyName=res.data;
                        this.formData.gsname=this.companyName[0].vc_name;
                        this.gsname=this.companyName[0].vc_name;
                        this.gsid=this.companyName[0].i_id;
                        this.vc_pricing_unit=this.companyName[0].vc_pricing_unit;
                        this.getGroupList();
                        if(this.formData.i_type==1){
                            this.wtflist();
                        }

                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getGroupList(){
                let param={
                    i_mid: this.mid,
                    i_type: "1",
                    i_gsid:this.gsid
                };
                let res=await API.getGroupList(param);
                if(res.code==1){
                    this.groupName=res.data;
                    if(this.groupName.length==1){
                        this.cjid=this.groupName[0].i_id
                        this.cjname=this.groupName[0].vc_name
                        this.formData.cjid=this.groupName[0].i_id
                        this.formData.cjname=this.groupName[0].vc_name
                        this.getScorderPzList()
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getPersonList(groupid){
                let param={
                    i_groupid:groupid,
                };
                let res=await API.getPersonList(param);
                if(res.code==1){
                    this.personName=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getWarehouseList(){
                let param={
                    i_mid: this.mid,
                };
                let res=await API.getWarehouseList(param);
                if(res.code==1){
                    if (res.data.length>0) {
                        this.warehouseName = res.data;
                        this.formData.ckname = this.warehouseName[0].vc_name;
                        this.ckname = this.warehouseName[0].vc_name;
                        this.ckid = this.warehouseName[0].i_id;
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getScorderPzList(){
                let param={
                    i_mid: this.mid,
                    i_cjid:this.cjid,
                    i_type:this.i_type==3?'0,3':this.i_type,
                };
                let res=await API.getScorderPzList(param);
                if(res.code==1){
                    this.proList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            changeCompany(val){
                //console.log("--gsis",val)
                if (this.formData.proname??''!==''){
                    this.formData.proname='';
                }
                this.formData.cjid=''
                this.formData.cjname=''
                this.cjid=''
                this.cjname=''
                this.gsid=val;
                let obj = this.companyName.find(item => item.i_id == val);
                this.gsname = obj.vc_name;
                this.vc_pricing_unit=obj.vc_pricing_unit;
                if ((this.gsid??''!=='')){
                    this.getGroupList();
                    if(this.formData.i_type==1)
                    this.wtflist();
                }
            },
            changeWtCompany(val){
                let obj = this.companyName.find(item => item.i_id == val);
                this.formData.vc_processingvendor = obj.vc_name;
            },
            changePro(val){
                // console.log("--gsis",val)
                this.pzid=val;
                let obj = this.proList.find(item => item.i_id == val);
                this.pzname = obj.vc_pzname;
                this.pzunit = obj.vc_pzunit;
                this.$forceUpdate()

            },
            changeWarehouse(val){
                this.ckid=val;
                let obj = this.warehouseName.find(item => item.i_id == val);
                this.ckname = obj.vc_name;
            },
            changeGroup(val){
                //console.log(groupid,"======")
                // if (this.formData.zdname??''!==''){
                //     this.formData.zdname='';
                // }
                if (this.formData.proname??''!==''){
                    this.formData.proname='';
                }
                this.cjid=val;
                let obj = this.groupName.find(item => item.i_id == val);
                this.cjname = obj.vc_name;
                if (this.cjid??''!==''){
                    // this.getPersonList(this.cjid);
                }
                if ((this.cjid??''!=='')&&(this.gsid??''!=='')){
                    this.proList=[];
                    this.getScorderPzList();
                }
            },
            changePerson(perid){
                // if (perid??''!=='') {
                //     this.zduid = perid;
                //     let obj = this.personName.find(item => item.i_id == perid);
                //     this.zdname = obj.vc_name;
                // }
            },
            async saveForm(){
                this.formData.delList=[]

                // console.log(this.formData.delList)
                if(this.i_id==0){
                    this.saveList= this.formData.tableData.map(item=>({
                        i_id:0,
                        f_num:item.f_num,
                        i_lruid:sessionStorage.getItem("userid"),
                        i_pid:0,
                        dt_day:item.dt_day
                    }))
                    this.formData.delList=[]

                }else {
                    if(this.deli_id==0){
                        this.formData.delList=[]
                    }

                    this.newdata=this.formData.tableData.map(item=>({

                        i_id:item.i_id,
                        f_num:item.f_num,
                        i_lruid:sessionStorage.getItem("userid"),
                        i_pid:item.i_pid,
                        dt_day:item.dt_day
                    }))
                    let arr1=this.olddata
                    let arr=[]
                    arr=this.newdata.filter(function(item){
                        return !arr1.some(ele=>ele.dt_day===item.dt_day&&ele.f_num===item.f_num)
                    })
                    this.saveList=arr
                }


                if (this.formData.gsname==''){
                    this.$message.error(this.$t('form_please_select_a_company'));
                    return
                }
                if (this.formData.cjname==''){
                    this.$message.error(this.$t('form_please_select_department'));
                    return
                }
                // if (this.formData.zdname==''){
                //     this.$message.error("请选择制单人");
                //     return
                // }
                if (this.formData.proname==''){
                    this.$message.error(this.$t('form_please_select_a_product'));
                    return
                }
                if (this.formData.ckname==''){
                    this.$message.error(this.$t('form_please_select_warehouse'));
                    return
                }
                if (this.i_type==3&&(this.formData.i_processingvendor==''||this.formData.i_processingvendor==null)){
                    this.$message.error(this.$t('promanagement_the_entrusted_factory_cannot_be_empty'));
                    return
                }
                if (this.i_type==1&&(this.formData.i_processingvendor==''||this.formData.i_processingvendor==null)){
                    this.$message.error('委托方不能为空');
                    return
                }
                if (this.formData.f_num==''){
                    // console.log(this.formData.f_num=='')
                    this.$message.error(this.$t('promanagement_please_fill_in_the_quantity'));
                    return
                }
                let tablevalid=this.formData.tableData.filter(item=>{
                    return item.f_num==0||item.dt_day==0||item.dt_day==null
                })
                if(tablevalid.length!==0){
                    this.$message.error(this.$t('promanagement_please_fill_in_the_production_date_and_planned_quantity'));
                    return
                }
                this.disabled=true;
                let param={
                    i_mid: this.mid,
                    i_id:this.i_id,
                    i_gsid:this.gsid,
                    i_cjid:this.cjid,
                    i_zduid:this.zduid,
                    // vc_zduname:this.zdname,
                    vc_pzname:this.pzname,
                    pzunit:this.pzunit,
                    vc_gsname:this.gsname,
                    vc_cjname:this.cjname,
                    vc_ckname:this.ckname,
                    i_ckid:this.ckid,
                    i_pzid:this.pzid,
                    vc_note:this.formData.vc_note,
                    f_fcost_price:this.formData.jgcost,
                    //i_type:0,
                    i_type:this.formData.i_type,
                    dt_createtime:this.formData.date,
                    list:this.saveList,
                    delIds:this.formData.delList,
                    dt_starttime:this.formData.begintime,
                    dt_endtime:this.formData.endtime,
                    f_num:this.formData.f_num,
                    //i_lruid:this.i_lruid,
                    // i_lruid:42,
                    // vc_lruname:" zyh",
                    // vc_lruname:this.formData.vc_lruname,
                    i_gid:this.cjid,
                    vc_pno:this.formData.num,
                    vc_pricing_unit:this.vc_pricing_unit,
                    i_processingvendor:this.formData.i_processingvendor,
                    //i_consignor_id:this.formData.i_consignor_id,
                };
                //console.log("save",this.formData.begintime);
                // console.log(param)
                // return
                let res=await API.saveScorder(param);
                if(res.code==1){
                    // this.$message.success(res.message);

                    let data=res.scorder;
                    data.dt_createtime=this.formatDate(data.dt_createtime);
                    data.dt_endtime =this.formatDate(data.dt_endtime);
                    if(this.i_id==0){
                        this.taskList(data,null);
                    }else{
                        this.taskList(data,this.formData.i_type);
                        if(this.formvalue.value.jz==true){
                            this.disabled=true;
                        }else{
                            this.disabled=false;
                        }
                    }
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                    // this.taskList(data);
                    this.formData.delList=[]
                    // this.i_id=res.scorder.i_id;
                    //this.disabled=true;

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            formatDate(str) {
                // 去掉 -
                str = str.replace(/-/g, "");
                // 如果有空格，说明有时分秒，就截掉后面
                if (str.includes(" ")) {
                    str = str.split(" ")[0];
                }
                return str;
            },
            taskList(data,newtype){
                // console.log("data",data,'newtype',newtype,'this.i_type',this.i_type);
                let val={
                    newtype:newtype,
                    i_itype:this.i_type,
                    expanded: true,
                    data:data,
                }
                this.$emit('proDetails',val);
                this.$nextTick(()=>{
                    this.i_type=newtype
                })
            },
            cancel(){},
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.date=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
            //得到最后一天
            getLastDay(val){
                let date=new Date(this.formData.begintime);
                date.setDate(28);
                date.setMonth(date.getMonth()+1);
                let lastDay=date.setDate(0);
                let allDay= new Date(lastDay).toString();
                const lastdate = new Date(allDay);
                const month = (lastdate.getMonth() + 1).toString().padStart(2, '0');
                const strDate = lastdate.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.lastTime=`${lastdate.getFullYear()}-${month}-${strDate}`;
                this.$set(this.formData, "endtime",this.lastTime)
                // console.log( value)
                //console.log("getLastDay",this.formData.begintime);
            },

        },
    }
</script>

<style lang="scss" scoped>
    .pd{
        min-width: 600px;
    }
    .flex{
        display: flex;
    }
    .item{
        width: 100%;
    }
    /deep/{
        .form-heji .el-form-item__label{
            font-weight: bold;
            color: black;
            font-size: 15px;
        }
        .num{
            margin-bottom: 12px;
        }
        .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
       /* .el-table td,.el-table td, .el-table th {
            padding: 8px 0;
        }*/
        .danger-row{
            color: #999;
        }

    }

    /*@media screen and (max-height: 770px) {
        .video-tree {
            //width: 420px;
            height: 600px;
        }
    }
    @media screen and (min-height: 900px) {
        .video-tree {
            //width: 530px;
            height: 600px;
        }
    }
    @media screen and (min-height: 780px) and (max-height: 830px) {
        .video-tree {
            //width: 450px;
            height: 600px;
        }
    }

    //实现滚动功能
    .video-tree {
        overflow-y: auto;
    }*/
</style>